module.exports = __webpack_public_path__ + "static/media/university-of-bath.e3154607.png";